import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Input from 'components/Shared/Input'
import { TransparentBgButton } from 'components/Shared/Button'
import { useToast } from 'components/Shared/AppToast/ToastProvider'

import {
  BACKHAUL_ATTRIBUTION_MODELS,
  fetchBackhaulAttribution,
  updateBackhaulAttribution,
} from 'api/backhaulAttribution'

function BackhaulAttribution() {
  const [attributionWindow, setAttributionWindow] = useState(14)
  const [model, setModel] = useState(BACKHAUL_ATTRIBUTION_MODELS.EVENTS_FROM_PACKAGE)
  const [isEditingMode, setIsEditingMode] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()
  const { addNotification } = useToast()

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true)

      const result = await fetchBackhaulAttribution()

      if (result.success) {
        setAttributionWindow(result.data.backhaul_evaluation_attribution_window)
        setModel(result.data.backhaul_evaluation_model)
      }

      setIsLoading(false)
    }

    loadData()
  }, [])

  const handleEditOrSave = async () => {
    if (!isEditingMode) {
      setIsEditingMode(true)
      return
    }

    const result = await updateBackhaulAttribution(+attributionWindow, model)

    if (result.success) {
      addNotification({
        message: t('common.success'),
        description: t('common.settingsUpdate'),
        variant: 'success',
      })
    } else {
      addNotification({
        message: t('common.genericError'),
        description: t('common.errors.inServerResponse'),
        variant: 'error',
      })
    }

    setIsEditingMode(false)
  }

  const options = [
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.ALL_PURCHASES,
      label: t('Settings.system.backhaulAttribution.modelType.allPurchases'),
    },
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.EVENTS_FROM_PACKAGE,
      label: t('Settings.system.backhaulAttribution.modelType.eventsFromPackage'),
    },
    {
      value: BACKHAUL_ATTRIBUTION_MODELS.EVENT_SERIES,
      label: t('Settings.system.backhaulAttribution.modelType.eventSeries'),
    },
  ]
  
  // return
  return (
    <div className="settings-page__sectionBody settings-page_backhaulAttribution">
      <div className="settings-page__sectionColumn w-100">
        <div className="settings-page__sectionWrapper align-items-start">
          <div className="settings-page__sectionState flex-wrap">
            <h3 className="settings-page__sectionTitle">
              {t('Settings.system.backhaulAttribution.title')}
            </h3>

            <p className="settings-page__sectionValue">
              {t('Settings.system.backhaulAttribution.description')}
            </p>

            <div className="form-wrapper mt-2">
              <div className="field-wrapper">
                <p className="label">{t('Settings.system.backhaulAttribution.attributionWindow')}</p>

                <div className="d-flex flex-row gap-2 align-items-center" style={{ width: 'fit-content' }}>
                  <Input
                    value={attributionWindow}
                    name="attributionWindow"
                    onChange={(e) => setAttributionWindow(e.target.value)}
                    type="number"
                    inputClass="days-input"
                    placeholder="0"
                    disabled={!isEditingMode || isLoading}
                    min={1}
                  />

                  <p className="mb-0">{t('Settings.system.backhaulAttribution.days')}</p>
                </div>
              </div>

              <div className="field-wrapper">
                <p className="label">{t('Settings.system.backhaulAttribution.model')}</p>

                <div className={`model-selector ${!isEditingMode ? 'disabled' : ''}`}>
                  {options.map((option) => (
                    <button
                      key={option.value}
                      type="button"
                      onClick={() => setModel(option.value)}
                      className={`btn  ${model === option.value ? 'button--active' : ''}`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          <TransparentBgButton
            text={isEditingMode ? t('common.save') : t('common.edit')}
            onClick={handleEditOrSave}
            fullWidth={false}
            color="navy"
            disabled={isLoading || (isEditingMode && (!model || !attributionWindow))}
          />
        </div>
      </div>
    </div>
  )
}

export default BackhaulAttribution